import { Component, OnInit } from '@angular/core';
import {FaqService} from '../Services/faq.service';
@Component({
  selector: 'app-app-faq',
  templateUrl: './app-faq.component.html',
  styleUrls: ['./app-faq.component.scss']
})
export class AppFaqComponent implements OnInit {

  constructor(private _faqService:FaqService) { }

  questions: any = [
    {
      "question": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم؟",
      "answer": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوم"
    },
    {
      "question": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم؟",
      "answer": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوم"
    },
    {
      "question": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم؟",
      "answer": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوم"
    },
    {
      "question": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم؟",
      "answer": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوم"
    },
    {
      "question": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم؟",
      "answer": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوملورم ایپسوم متن ساختگی با تولید سادگی نامفهوم"
    }
  ]
  openQuestion(element: any) {
    let ele = element.currentTarget
    let active = document.querySelector(".question.active");
    if (!ele.classList.contains("active") && ele != active) {
      ele.classList.add('active')
      active?.classList.remove('active')

    }
    else {
      ele.classList.remove('active')
    }

  }
  ngOnInit(): void {
    this._faqService.getQuestion().subscribe((data)=>{
      console.log(data)
      this.questions = data.data;
    })

  }

}
